<template>
  <a-button
    class="mx-2 !border-none text-[var(--primary-color-2)] cursor-pointer"
    @click="touristVisit"
  >
    {{ t('sys.touristVisit') }}
  </a-button>
</template>

<script setup lang="ts">
  import { useI18n } from '/@/hooks/web/useI18n';
  import { useGo } from '/@/hooks/web/usePage';
  import { PageEnum } from '/@/enums/pageEnum';

  const { t } = useI18n();
  const go = useGo();
  const touristVisit = () => {
    go(PageEnum.MARKET_INDEX);
  };
</script>
